import { FC } from 'react'
import classNames from 'classnames'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import IntlTelInput from '@andrewsantarin/react-intl-tel-input'
import { PREFERRED_PHONE_COUNTRIES } from 'features/registration/constants'
import { PhoneFormFieldProps as Props } from '../types'
import { CountryCode } from 'libphonenumber-js/types'

const PhoneFormField: FC<Props> = ({
  control,
  formState,
  setError,
  clearErrors,
  hookFormSelector,
  isRequired,
  label,
  setValue,
  setCountryCode
}) => {
  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  // Constants
  const key = hookFormSelector ?? 'mobilePhone'
  const { errors } = formState

  return (
    <div className="form-input">
      <label htmlFor={key} className="margin-bottom-xs">
        {label ?? t('phone', 'Telefoonnummer')}
      </label>
      <Controller
        name={key}
        control={control}
        rules={{ required: isRequired }}
        render={({ field: { name, onChange, onBlur, value } }) => (
          <IntlTelInput
            containerClassName="intl-tel-input is-fullwidth"
            inputClassName={classNames('border', { 'has-error': errors && key in errors })}
            preferredCountries={PREFERRED_PHONE_COUNTRIES}
            value={value}
            onPhoneNumberChange={(valid: boolean, value: string, countryData) => {
              setValue(name, value)
              onChange(value)
              if (!valid) {
                setError(name, { type: 'invalid' })
              } else {
                clearErrors(name)
              }
              if (setCountryCode) setCountryCode(countryData.iso2.toUpperCase() as CountryCode)
            }}
            onPhoneNumberBlur={(valid: boolean, value: string, countryData) => {
              setValue(name, value)
              onBlur()
              if (setCountryCode) setCountryCode(countryData.iso2.toUpperCase() as CountryCode)
            }}
          />
        )}
      />
      {errors?.[key] && (
        <p className="margin-top-s margin-bottom-none is-red">
          {errors[key]?.type === 'required' && t('validation:required')}
          {errors[key]?.type === 'invalid' && t('validation:phone')}
        </p>
      )}
    </div>
  )
}

export default PhoneFormField
